import { buildApiUrl, sendGetRequest, sendPostRequest, Type } from '@/api/api'
import { assertSchemaAndReturn } from '@/helpers/assert-schema'
import { z } from 'zod'
import * as validation from '@/helpers/validation'
import { TariffsSchema, UtilityProvidersSchema } from './schemas';

function isAdditionalCharge(chargeId: number) {
  return chargeId > 6;
}

export async function getUtilities(countryId: number|undefined = undefined) {
  const url = buildApiUrl(Type.TariffManagement, 'providers')

  if (countryId) {
    url.searchParams.set('countryId', countryId.toString())
  }

  const { data } = await sendGetRequest(url)
  return assertSchemaAndReturn(
    data,
    UtilityProvidersSchema
  )
}

export async function getTariffsByUtilityId(utilityId: number) {

  const { data } = await sendPostRequest(buildApiUrl(Type.TariffManagement, `tariffs?providerId=${utilityId}`))
  const tariffs = assertSchemaAndReturn(
    data,
    TariffsSchema
  )

  return tariffs.map(
    tariff => ({
      id: tariff.Id,
      name: tariff.Name + ' (' + tariff.Source + ')' + ' - ' + tariff.Periods[0].YearOfTariff,
      isTimeOfUse: tariff.IsTimeOfUse,
      additionalCharges: tariff.Periods
        .filter(x => isAdditionalCharge(x.ChargeNameId))
        .map(
          period => ({
            id: period.Id,
            name: period.ChargeName,
            rateInCents: period.RateInCents,
            seasonId: period.SeasonId,
            seasonName: period.Season,
            year: period.YearOfTariff,
          })
        ),
      bands: tariff.Periods
        .filter(x => !isAdditionalCharge(x.ChargeNameId))
        .map(
          period => ({
            id: period.Id,
            name: tariff.IsTimeOfUse
              ? period.TimeOfUse ?? 'Unknown'
              : period.ChargeName,
            seasonId: period.SeasonId,
            seasonName: period.Season,
            rangeStart: period.StartOfPeriod,
            rangeEnd: period.EndOfPeriod,
            rateInCents: period.RateInCents,
            year: period.YearOfTariff,
          })
        )
    })
  ).sort((a, b) => a.name.localeCompare(b.name))
}
